/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';

import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type SaveFilterDialogBaseQuery,
} from '../../common/ui/save-filter-dialog-base/__generated__/SaveFilterDialogBaseQuery.graphql';
import type { SaveFilterDialogEntryPointEntrypointProps } from './save-filter-dialog-content/SaveFilterDialogEntryPoint.entrypoint.types.tsx';

type EntryPointParams = {
	filterAri?: string;
};

type SaveFilterDialogEntryPointComponent = EntryPointComponent<
	{
		filterDataQuery: SaveFilterDialogBaseQuery;
	},
	{},
	SaveFilterDialogEntryPointEntrypointProps,
	{}
>;

export const saveFilterDialogEntryPoint: EntryPoint<
	SaveFilterDialogEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<SaveFilterDialogEntryPointComponent>(
		/* webpackChunkName: "async-issue-navigator-save-filter-dialog-content" */ './save-filter-dialog-content/index.tsx',
	),
	getPreloadProps: ({ filterAri }: EntryPointParams) => ({
		queries: {
			filterDataQuery: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					filterAri: filterAri ?? '',
					includeFilter: !!filterAri,
				},
			},
		},
	}),
});
